import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { ICocRecommendationSummary } from '@publishing-engine/domain/models';
import RecommendationSubmitted from './RecommendationSubmitted';
interface Props {
  round: ICocRecommendationSummary | undefined;
}

const COCRecommendation: React.FC<Props> = ({ round }) => {
  const reversedRound = [...(round?.cycles || [])];

  return reversedRound?.length ? (
    <>
      <Box my={2}>
        <Text textStyle="headingLine" mb={2}>
          Recommendations ({round?.recommendationsCount ?? 0})
        </Text>
        <Divider />
      </Box>
      {reversedRound.map((cycle, index) => {
        const reversedParticipants = [...(cycle?.participants || [])];
        return (
          <Flex key={index} gap={4} flexDirection="column">
            <Box
              border={'1px solid'}
              borderStyle="solid"
              borderColor="neutralPrimaryBorder"
              mt={2}
            >
              {reversedParticipants.map(participant => (
                <Box
                  borderBottom={'1px'}
                  borderStyle="solid"
                  padding={3}
                  _last={{ borderBottom: '0px' }}
                  borderColor="neutralPrimaryBorder"
                >
                  {participant.recommendation ? (
                    <RecommendationSubmitted participant={participant} />
                  ) : (
                    <Flex justifyContent={'space-between'}>
                      <Text textStyle={'headingOverline'}>
                        <Text as={'span'} textStyle={'headingItem'}>
                          {participant.role}{' '}
                        </Text>
                        : {participant.userFirstName} {participant.userLastName}
                      </Text>

                      {participant.status === 'awaiting' ? (
                        <Text textStyle="textContext" color="gray.500">
                          Awaiting Recommendation
                        </Text>
                      ) : (
                        <Text
                          textStyle="textContext"
                          textTransform={'capitalize'}
                          color="gray.500"
                        >
                          {participant.status}
                        </Text>
                      )}
                    </Flex>
                  )}
                </Box>
              ))}
            </Box>
          </Flex>
        );
      })}
    </>
  ) : (
    <>
      <Box
        border={'1px solid'}
        borderStyle="solid"
        borderColor="neutralPrimaryBorder"
        p={3}
        my={2}
      >
        <Text textStyle="textContext">
          No recommendations or decisions have been made yet.
        </Text>
      </Box>
    </>
  );
};

export default COCRecommendation;
